import { createContext, useContext } from "react";

/**
 * True for everything rendered inside the persistent EntryShell. Shared
 * components (OnboardingLayout, AddressForm, ErrorComponent, Overlay…)
 * use this to render their entry-styled variant without any prop threading,
 * while dashboard-side usages keep the classic design.
 */
export const EntryShellContext = createContext(false);

export const useIsInEntryShell = () => useContext(EntryShellContext);
